// extracted by mini-css-extract-plugin
module.exports = {"shwing_num":"show_paginate_text_shwing_num__U1FWs"};